import React from "react";
import "./style.scss";
import { RightOutlined } from "@ant-design/icons";
export default () => {
  return (
    <div>
      <div className={"user_content_header"}>
        <ul>
          <li>
            <span>我的工具</span>
            <RightOutlined className={"iconArrow"} />
            <span>标的物订阅</span>
          </li>
        </ul>
      </div>
      <div className={"subscribe-container"}>
        <img
          src="https://api.faeping.com/storage/uploads/20250407/1743995900558_%E8%AE%A2%E9%98%852x.png"
          alt=""
        />
      </div>
    </div>
  );
};
